import React from "react";
import * as T from "./types";
import * as S from "./styles";
import C from "@assets/themes/colors";
import FolderIcon from "@assets/icons/folderIcon";
import ClickOutside from "@components/ClickOutside";
import selectors from "@state/selectors";
import { FolderContainer, FolderIconContainer, ItemContainer } from "../AssetsExplorer/styles";
import Input from "@components/Input";
import { IDSConfig } from "@state/dsconfig/types";
import { useSelector } from "react-redux";
import WarningIcon from "@assets/icons/warningIcon";

const NewFolderControls: React.FC<T.IProps> = (props) => {

  const dsConfig: IDSConfig | undefined = useSelector(selectors.dsConfig.getDSConfig);

  const [value, setValue] = props.folderName;
  const [isRepeated, setIsRepeated] = props.repeatedName;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    if (dsConfig && inputValue.length < dsConfig.editorConfig.exportingValues.folderNameMaxSize) {
      setValue(inputValue);
      if (props.folderNames.includes(inputValue)) setIsRepeated(true);
      else setIsRepeated(false);
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code === "Enter") props.handleOpenEmptyFolder();
  }

  const handleCancel = (e: KeyboardEvent) => {
    if (e.code === "Escape") props.closeNewFolderControls();
  }

  React.useEffect(() => {
    document.addEventListener("keydown", handleCancel, false);
    return () => document.removeEventListener("keydown", handleCancel, false);
  }, []);

  return (
    <S.Root>
      <ClickOutside
        onClickOutside={props.handleOpenEmptyFolder}
        event="mouseup"
        refresh={props.folderName}
      >
        <ItemContainer>
          <FolderContainer
            onDoubleClick={props.handleOpenEmptyFolder}
          >
            <FolderIconContainer>
              <FolderIcon />
            </FolderIconContainer>
          </FolderContainer>
          <Input
            id="new-folder-input"
            placeholder=""
            value={value}
            handleChange={handleChange}
            onKeyPress={handleKeyPress}
            disabled={false}
            style={S.ContainerInputStyle}
            inputStyle={{
              ...S.InputStyle,
              color: isRepeated ? C.RED : C.DARK_GRAY,
            }}
          />
          {
            isRepeated &&
            <S.WarningError>
              Folder name already exists
              <WarningIcon />
            </S.WarningError>
          }
        </ItemContainer>
      </ClickOutside>
    </S.Root>
  );
}

export default NewFolderControls;